export default {"src":"/_next/static/media/person.12ee7b0a.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};